export default __webpack_public_path__ + "9bd5a50a103768eca13af5c01c3d1ea5.png";